import { Divider } from '@material-ui/core';
import FilterIcon from '@shared/icons/FilterIcon';
import PopoverSelect from '@shared/Reports/PopoverSelect';
import PopoverCombobox from '@shared/Reports/PopoverCombobox';
import { getMyCompanies, getMySchools } from '@/app/services/schools/schools';
import { useState } from 'react';

const RoyaltyPaymentFiltersBar = ({ filters, setFilters }) => {
	const now = new Date();
	const currentYear = now.getFullYear();
	const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
	const [schoolOptions, setSchoolOptions] = useState([]);
	const [schoolLoading, setSchoolLoading] = useState(false);

	const [companyOptions, setCompanyOptions] = useState([]);
	const [companyLoading, setCompanyLoading] = useState(false);

	const handleQuarterAndYearChange = (newPart) => {
		const next = { ...filters, ...newPart };
		const yearVal = next.year?.value ?? null;
		const quarterVal = next.quarter?.value ?? null;

		const maxQuarter = yearVal === currentYear ? currentQuarter : 4;
		const adjustedQuarter = quarterVal == null ? null : Math.min(quarterVal, maxQuarter);
		setFilters({
			...next,
			year: yearVal == null ? null : { value: yearVal, label: `${yearVal}` },
			quarter: adjustedQuarter == null ? null : { value: adjustedQuarter, label: `Q${adjustedQuarter}` },
		});
	};

	return (
		<div className="text-white py-16 px-32 justify-between flex" style={{ background: 'rgb(0, 46,108)' }}>
			<span className="flex items-center gap-8 text-16">
				<FilterIcon /> Filter:
			</span>
			<div className="flex gap-8 md:gap-16">
				<PopoverCombobox
					currentFilter="school_id"
					filters={filters}
					options={schoolOptions}
					loading={schoolLoading}
					setFilter={setFilters}
					onSearch={async (q) => {
						try {
							setSchoolLoading(true);
							const res = await getMySchools(q, 1);
							const list = res?.data?.data || res?.data || [];
							setSchoolOptions(list.map((s) => ({ label: s?.name, value: s?.id })));
						} finally {
							setSchoolLoading(false);
						}
					}}
					title="School"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverCombobox
					currentFilter="company_id"
					filters={filters}
					options={companyOptions}
					loading={companyLoading}
					setFilter={setFilters}
					onSearch={async (q) => {
						try {
							setCompanyLoading(true);
							const res = await getMyCompanies(q, 1);
							const list = res?.data?.data || res?.data || [];
							setCompanyOptions(list.map((s) => ({ label: s?.name, value: s?.id })));
						} finally {
							setCompanyLoading(false);
						}
					}}
					title="Company"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="year"
					filters={filters}
					options={(() => {
						const years = [];
						for (let y = currentYear; y >= currentYear - 4; y -= 1) years.push({ label: `${y}`, value: y });
						return years;
					})()}
					setFilter={handleQuarterAndYearChange}
					title="Year"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="quarter"
					filters={filters}
					options={(() => {
						const yearVal = filters.year?.value;
						const maxQuarter = yearVal == null ? 4 : yearVal === currentYear ? currentQuarter : 4;
						return Array.from({ length: maxQuarter }, (_, i) => ({ label: `Q${i + 1}`, value: i + 1 }));
					})()}
					setFilter={handleQuarterAndYearChange}
					title="Quarter"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="status"
					filters={filters}
					options={[
						{ label: 'All', value: 'all' },
						{ label: 'Paid', value: 'paid' },
						{ label: 'Unpaid', value: 'unpaid' },
					]}
					setFilter={setFilters}
					title="Status"
				/>
			</div>
		</div>
	);
};

export default RoyaltyPaymentFiltersBar;
